import { hkClassics } from "@/mocks/films";

export default function HkClassics() {
  return (
    <section id="hk-classics" className="w-full bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <header className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label text-primary-700 bg-primary-100 px-3 py-1.5 rounded-full">
              <i className="ri-earth-line" aria-hidden="true"></i>
              港片精选
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug">
              六部常被重看的港片，各自代表一种讲法
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              港片的迷人之处在于类型之间的自由流动：黑帮、警匪、喜剧与爱情常常挤在同一部片里。
              下面这六部作品从不同角度展示了这种混合感，可以作为进入港片的几条不同路径。
            </p>
          </header>

          <ul className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {hkClassics.map((film) => (
              <li
                key={film.id}
                className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200"
              >
                <div className="relative w-full h-[260px] md:h-[300px] overflow-hidden">
                  <img
                    src={film.image}
                    alt={`${film.title} 风格海报插画`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-950/70 text-accent-400 text-xs font-label">
                    {film.year}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-4 md:p-5">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{film.title}</h3>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    {film.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-full text-[11px] bg-secondary-100 text-secondary-900 font-label"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{film.line}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}